import Modal from "../../../controls/Modal";
import Table from "../../../controls/Table";
import Toggle from "../../../controls/Toggle";
import { Button } from "../../../controls/TooltipControls";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import { setdefault } from "../../../util/util";
import { confirmExternalChanges, setExternalChangeAction, } from "../actions/session";
import update from "immutability-helper";
import * as React from "react";
// Adding these to assist with capturing and debugging
//  invalid action errors - will remove this once we're able
//  to deduct what is happening in reports such as:
//  https://github.com/Nexus-Mods/Vortex/issues/7629
import path from "path";
import getVortexPath from "../../../util/getVortexPath";
import { getReduxLog } from "../../../store/reduxLogger";
const nop = () => undefined;
const possibleActions = {
    refchange: [
        {
            key: "drop",
            text: "Revert change (use staging file)",
            allText: "Revert all changes",
        },
        {
            key: "import",
            text: "Save change (use deployed file)",
            allText: "Save all changes",
        },
        {
            key: "newest",
            text: "Use newer file",
            allText: "Use newer file for all changes",
        },
    ],
    valchange: [
        { key: "nop", text: "Save change", allText: "Save all changes" },
        // TODO: implement a "restore from archive" option
    ],
    deleted: [
        {
            key: "restore",
            text: "Revert change (restore file)",
            allText: "Revert all changes",
        },
        {
            key: "delete",
            text: "Save change (delete file)",
            allText: "Save all changes",
        },
    ],
    srcdeleted: [
        {
            key: "import",
            text: "Revert change (restore file)",
            allText: "Revert all changes",
        },
        {
            key: "drop",
            text: "Save change (delete file)",
            allText: "Save all changes",
        },
    ],
};
function bySource(prev, value) {
    setdefault(prev, value.source, []).push(value);
    return prev;
}
function transform(source, files) {
    return {
        id: source,
        filePaths: files.map((file) => file.filePath),
        action: files[0].action,
        modTypeId: files[0].modTypeId,
        type: files[0].type,
    };
}
class ExternalChangeDialog extends ComponentEx {
    setAll = {
        refchange: (evt) => {
            this.setAllFunc("refchange", evt.currentTarget.href.split("#")[1]);
        },
        valchange: (evt) => {
            this.setAllFunc("valchange", evt.currentTarget.href.split("#")[1]);
        },
        deleted: (evt) => {
            this.setAllFunc("deleted", evt.currentTarget.href.split("#")[1]);
        },
        srcdeleted: (evt) => {
            this.setAllFunc("srcdeleted", evt.currentTarget.href.split("#")[1]);
        },
    };
    constructor(props) {
        super(props);
        this.state = { showFiles: false };
    }
    render() {
        const { t, changes } = this.props;
        const { showFiles } = this.state;
        const refChanged = changes.filter((change) => change.type === "refchange");
        const valChanged = changes.filter((change) => change.type === "valchange");
        const deleted = changes.filter((change) => change.type === "deleted");
        const srcDeleted = changes.filter((change) => change.type === "srcdeleted");
        const renderFunc = showFiles ? this.renderFiles : this.renderSources;
        return (React.createElement(Modal, { id: "ext-change-dialog", show: changes.length > 0, onHide: nop },
            React.createElement(Modal.Header, null,
                React.createElement(Modal.Title, null, t("External Changes"))),
            React.createElement(Modal.Body, null,
                React.createElement("div", { style: { display: "flex", flexDirection: "column", height: "100%" } },
                    React.createElement("div", { className: "padded-text", style: { flex: 0 } }, t("Mod files were changed outside Vortex. " +
                        "You can undo these changes now or apply them permanently.")),
                    renderFunc(refChanged, valChanged, deleted, srcDeleted)),
                React.createElement(Toggle, { checked: showFiles, onToggle: this.toggleShowFiles }, t("Show individual files"))),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { id: "btn-cancel-activation", tooltip: t("Cancel deployment"), onClick: this.cancel }, t("Cancel")),
                React.createElement(Button, { id: "btn-confirm-activation", tooltip: t("Confirm changes"), onClick: this.confirm }, t("Confirm")))));
    }
    renderSources = (refChanged, valChanged, deleted, srcDeleted) => {
        const { t } = this.props;
        const rcmap = refChanged.reduce(bySource, {});
        const vcmap = valChanged.reduce(bySource, {});
        const dmap = deleted.reduce(bySource, {});
        const sdmap = srcDeleted.reduce(bySource, {});
        const rc = Object.keys(rcmap).map((source) => transform(source, rcmap[source]));
        const vc = Object.keys(vcmap).map((source) => transform(source, vcmap[source]));
        const d = Object.keys(dmap).map((source) => transform(source, dmap[source]));
        const sd = Object.keys(sdmap).map((source) => transform(source, sdmap[source]));
        return (React.createElement("div", { style: { display: "flex", flexDirection: "column", height: "100%" } },
            this.renderChangedSources(t("File content modified " +
                '("Save" will apply the changed file from the game folder permanently, ' +
                '"Revert" will restore the original file from the staging folder)'), "refchange", rc),
            this.renderChangedSources(t("Source files were deleted " +
                '("Save" will remove the corresponding files permanently, "Revert" will restore them)'), "srcdeleted", sd),
            this.renderChangedSources(t("Links were deleted " +
                '("Save" will remove the corresponding source files permanently, ' +
                '"Revert" will recreate the links)'), "deleted", d)));
    };
    renderFiles = (refChanged, valChanged, deleted, srcDeleted) => {
        const { t, changes } = this.props;
        return (React.createElement("div", { style: { display: "flex", flexDirection: "column", height: "100%" } },
            this.renderChangedFile(t("File content modified " +
                '("Save" will apply the changed file from the game folder permanently, ' +
                '"Revert" will restore the original file from the staging folder)'), "refchange", refChanged),
            this.renderChangedFile(t("Source files were deleted" +
                '("Save" will remove the files permanently, "Revert" will restore them)'), "srcdeleted", srcDeleted),
            this.renderChangedFile(t("Links were deleted" +
                '("Save" will delete the corresponding source files, ' +
                '"Revert" will recreate the links)'), "deleted", deleted)));
    };
    renderChangedSources = (text, type, entries) => {
        const { t } = this.props;
        if (entries.length === 0) {
            return null;
        }
        const columns = this.genSourceColumns(type);
        const actions = possibleActions[type];
        return (React.createElement("div", { style: { flex: "1 1 0", display: "flex", flexDirection: "column" } },
            text,
            React.createElement("p", null, actions.map((action) => (React.createElement(React.Fragment, { key: action.key },
                React.createElement("a", { onClick: this.setAll[type], href: "#" + action.key }, t(action.allText)),
                React.createElement("span", { className: "link-action-seperator" }, "\u00A0 | \u00A0"))))),
            React.createElement("div", { style: { overflowY: "auto", flex: "1 1 0" } },
                React.createElement(Table, { tableId: `external-change-${type}`, data: entries, actions: [], staticElements: columns, showHeader: false, showDetails: false }))));
    };
    renderChangedFile = (text, type, entries) => {
        const { t } = this.props;
        if (entries.length === 0) {
            return null;
        }
        const columns = this.genColumns(type);
        const actions = possibleActions[type];
        return (React.createElement("div", { style: { flex: "1 1 0", display: "flex", flexDirection: "column" } },
            text,
            React.createElement("p", null, actions.map((action) => (React.createElement("a", { key: action.key, onClick: this.setAll[type], href: "#" + action.key, style: { marginRight: 10 } }, t(action.allText))))),
            React.createElement("div", { style: { overflowY: "auto", flex: "1 1 0" } },
                React.createElement(Table, { tableId: `external-change-${type}`, data: entries, actions: [], staticElements: columns, showDetails: false }))));
    };
    reportInvalidAction(type, action) {
        const { changes } = this.props;
        getReduxLog().then((logData) => {
            const state = this.context.api.getState();
            const sessionData = state.session;
            this.context.api.showErrorNotification("Invalid action", { type, action }, {
                attachments: [
                    {
                        id: "logfile",
                        type: "file",
                        data: path.join(getVortexPath("userData"), "vortex.log"),
                        description: "Vortex Log",
                    },
                    {
                        id: "events",
                        type: "data",
                        data: logData,
                        description: "Events Log",
                    },
                    {
                        id: "changes",
                        type: "data",
                        data: changes,
                        description: "External Changes Log",
                    },
                    {
                        id: "session",
                        type: "data",
                        data: sessionData,
                        description: "Session State",
                    },
                ],
            });
        });
    }
    // tslint:disable-next-line:member-ordering
    genSourceColumns = (() => {
        const cache = {};
        return (type) => {
            if (cache[type] === undefined) {
                cache[type] = [
                    {
                        id: "name",
                        name: "Mod Name",
                        description: "Mod Name",
                        calc: (source) => source.id,
                        placement: "table",
                        edit: {},
                    },
                    {
                        id: "file_count",
                        name: "File Count",
                        description: "Number of files in this mod that were changed",
                        calc: (source, t) => t("{{count}} file", {
                            count: source.filePaths !== undefined ? source.filePaths.length : 0,
                        }),
                        placement: "table",
                        edit: {},
                    },
                    {
                        id: "action",
                        name: "Action",
                        description: "the action to take on files in this mod",
                        calc: (source) => {
                            const action = possibleActions[type].find((act) => act.key === source.action);
                            if (action === undefined) {
                                this.reportInvalidAction(type, source.action);
                                return "INVALID!";
                            }
                            return action.text;
                        },
                        placement: "table",
                        edit: {
                            inline: true,
                            choices: () => possibleActions[type],
                            onChangeValue: (source, value) => {
                                let newAction = value;
                                if (value === undefined) {
                                    const typeActions = possibleActions[type];
                                    const idx = typeActions.findIndex((act) => act.key === source.action);
                                    newAction = typeActions[(idx + 1) % typeActions.length]
                                        .key;
                                }
                                // TODO: the way source is created, filePaths should never be undefined and
                                //   I wasn't able to reproduce a case where it was, but we did get a crash
                                //   report where it was.
                                if (source.filePaths !== undefined) {
                                    source.filePaths.forEach((filePath) => this.props.onChangeAction([filePath], newAction));
                                }
                            },
                        },
                    },
                ];
            }
            return cache[type];
        };
    })();
    // tslint:disable-next-line:member-ordering
    genColumns = (() => {
        const cache = {};
        return (type) => {
            if (cache[type] === undefined) {
                cache[type] = [
                    {
                        id: "name",
                        name: "File Name",
                        description: "file name",
                        calc: (file) => file.filePath,
                        placement: "table",
                        edit: {},
                    },
                    {
                        id: "staged_changed",
                        name: "Staged file modified",
                        description: "Last time the stage file (the one in the mod staging folder) was modified",
                        calc: (file, t) => file.sourceModified !== undefined
                            ? file.sourceModified.toLocaleString()
                            : "",
                        placement: "table",
                        edit: {},
                    },
                    {
                        id: "deployment_changed",
                        name: "Deployed file modified",
                        description: "Last time the deployed file (the one in the game folder) was modified",
                        calc: (file) => file.destModified !== undefined
                            ? file.destModified.toLocaleString()
                            : "",
                        placement: "table",
                        edit: {},
                    },
                    {
                        id: "action",
                        name: "Action",
                        description: "the action to take on the file",
                        calc: (file) => {
                            const action = possibleActions[type].find((act) => act.key === file.action);
                            if (action === undefined) {
                                this.reportInvalidAction(type, file.action);
                                return "INVALID!";
                            }
                            return action.text;
                        },
                        placement: "table",
                        edit: {
                            inline: true,
                            choices: () => possibleActions[type],
                            onChangeValue: (file, value) => {
                                const typeActions = possibleActions[type];
                                const idx = typeActions.findIndex((act) => act.key === file.action);
                                if (idx < 0) {
                                    return;
                                }
                                if (value === undefined) {
                                    this.props.onChangeAction([file.filePath], typeActions[(idx + 1) % typeActions.length]
                                        .key);
                                }
                                else {
                                    this.props.onChangeAction([file.filePath], value);
                                }
                            },
                        },
                    },
                ];
            }
            return cache[type];
        };
    })();
    toggleShowFiles = () => {
        this.setState(update(this.state, { showFiles: { $set: !this.state.showFiles } }));
    };
    setAllFunc = (changeType, action) => {
        const { changes, onChangeAction } = this.props;
        onChangeAction(changes
            .filter((entry) => entry.type === changeType)
            .map((entry) => entry.filePath), action);
    };
    cancel = () => {
        this.props.onClose([], true);
    };
    confirm = () => {
        const deletions = this.props.changes.filter((change) => change.action === "delete");
        if (deletions.length > 1) {
            this.context.api
                .showDialog("question", "Confirm deletion", {
                bbcode: 'You\'re about to [color="red"]delete[/color] {{count}} files. ' +
                    "Are you sure this is what you want?",
                parameters: {
                    count: deletions.length,
                },
            }, [{ label: "Back" }, { label: "Continue" }])
                .then((result) => {
                if (result.action === "Continue") {
                    this.props.onClose(this.props.changes, false);
                }
            });
        }
        else {
            this.props.onClose(this.props.changes, false);
        }
    };
}
function mapStateToProps(state) {
    return {
        changes: state.session.mods.changes,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onChangeAction: (fileName, action) => dispatch(setExternalChangeAction(fileName, action)),
        onClose: (changes, cancel) => dispatch(confirmExternalChanges(changes, cancel)),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(ExternalChangeDialog));
